import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import Layout from 'components/Layout'
import Nav from 'components/Nav'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'

import {
  BreakdownContainer,
  Footer,
  MainDescription,
  MainHeading,
  SubDescription,
  SubHeading,
  SustainableItem,
  SustainableItemDescription,
} from './styled-components'

type Props = WithFlowRouterProps

const AboutESG = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const onBackOverride = () => props.route({ from: FlowRoute.AboutESG, action: 'goBack' })

  return (
    <>
      <Nav back={true} hideProgressBar={true} title="About ESG" onBackOverride={onBackOverride} />
      <Layout>
        <MainHeading>
          {getRemoteString({
            key: 'portfolio.about_sustainability.title1',
          })}
        </MainHeading>
        <MainDescription>
          {getRemoteString({
            key: 'portfolio.about_sustainability.title1.description',
          })}
        </MainDescription>
        <BreakdownContainer>
          <SustainableItem>
            <AcornsIcon icon={AcornsIcon.Icon.SustainableWindmill} width="150px" height="96px" />
            <SubHeading>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title2',
              })}
            </SubHeading>
            <SustainableItemDescription>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title2.description',
              })}
            </SustainableItemDescription>
          </SustainableItem>
          <SustainableItem>
            <AcornsIcon icon={AcornsIcon.Icon.SustainableHand} width="150px" height="96px" />
            <SubHeading>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title3',
              })}
            </SubHeading>
            <SustainableItemDescription>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title3.description',
              })}
            </SustainableItemDescription>
          </SustainableItem>
          <SustainableItem>
            <AcornsIcon icon={AcornsIcon.Icon.SustainableScale} width="150px" height="96px" />
            <SubHeading>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title4',
              })}
            </SubHeading>
            <SustainableItemDescription>
              {getRemoteString({
                key: 'portfolio.about_sustainability.title4.description',
              })}
            </SustainableItemDescription>
          </SustainableItem>
        </BreakdownContainer>

        <SubDescription>
          {getRemoteString({
            key: 'portfolio.about_sustainability.bottom_description',
          })}
        </SubDescription>
        <Footer>
          {getRemoteString({
            key: 'portfolio.about_sustainability.footer',
          })}
        </Footer>
        <Footer>
          {getRemoteString({
            key: 'portfolio.about_sutainability.footer2',
          })}
        </Footer>
      </Layout>
    </>
  )
}

export default withFlowRouter(AboutESG)
